export default __webpack_public_path__ + "static/media/mic.e4c91b82.svg";